module.exports = __webpack_public_path__ + "images/270433ca7cb9e99f8862652a8450d6dd.png";